import React from 'react';
import { View, Text } from 'react-native';

import HeaderDefault from '../../components/HeaderDefault';
import Button from '../../components/Button';

import styles from './styles';

const QrCodeConfirmTransferPix = () => {
    return (
        <>
            <HeaderDefault title={"QrCode"} />

            <View style={styles.container}>

                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}>Valor da transferência:</Text>
                    <Text>XXX,XXX.XXBRL</Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}>Recebedor:</Text>
                    <Text>Abelardo Bueno da Costa</Text>
                </View>
            </View>

            <Button route={"ConfirmPassword"} text={"CONTINUAR"} titlePage={"Confirmar tranferência"} />
        </>
    );
}

export default QrCodeConfirmTransferPix;